export function addZammitUpdates(state, response) {
  state.zammitUpdates = response;
}

export function setZammitUpdatesLoading(state, value) {
  state.loading = value;
}
